import './styles.css';

import React, { Component } from 'react';



class InputField extends Component {

    onChange = (event) => {

        this.props.onChange(event.target.value);

    };

    render() {

        const {
            type,
            placeholder,
            value
        } = this.props;

        return (
            <div className="input-field-get-in-touch">
                {
                    type === "text" ?
                        <input
                            type = { type }
                            placeholder = { placeholder }
                            value = { value }
                            onChange = { this.onChange }
                        />
                        :
                        <textarea
                            placeholder = { placeholder }
                            value = { value }
                            onChange = { this.onChange }
                        />
                }


            </div>
        )

    }

}

export default InputField;



// WEBPACK FOOTER //
// ./src/components/InputField/InputField.js